console.log('Ready javascript');

// empty - export code to :: assets/js/scripts.js

//